import type { PropsWithChildren } from 'react';

import { useUserTrialDetails } from '@revelio/auth';

import { DataBuilderTrialPage } from './components/DataBuilderTrialPage';

export const DataBuilderRouteGuard = ({ children }: PropsWithChildren) => {
  const { isTrialUser } = useUserTrialDetails<boolean>({
    initialRenderValue: false,
  });

  if (isTrialUser) {
    return <DataBuilderTrialPage />;
  }

  return children;
};
